var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.093,
    height: 11.33,
    viewBox: "0 0 13.093 9.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    transform: "translate(0 -75.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M12.079,75.31H1.013A1.019,1.019,0,0,0,0,76.323v7.305A1.019,1.019,0,0,0,1.013,84.64H12.079a1.019,1.019,0,0,0,1.013-1.013V76.323A.989.989,0,0,0,12.079,75.31ZM8.294,80.252,12.513,77v6.534Zm-7.257-4.34H12.079a.441.441,0,0,1,.41.313L6.9,80.566a.651.651,0,0,1-.772,0L.6,76.274A.463.463,0,0,1,1.037,75.913ZM.6,83.531V77.046l4.171,3.231Zm.434.555a.181.181,0,0,1-.121-.024l4.364-3.4.482.386a1.2,1.2,0,0,0,.747.241,1.159,1.159,0,0,0,.747-.241l.53-.41L12.2,84.062a.217.217,0,0,1-.121.024H1.037Z",
    fill: "#29a19c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.298231817cf759b7648b8dc5e3c779aa.svg";
export { ForwardRef as ReactComponent };